
import React, { useState } from 'react';
import { Popover } from "@mui/material";
import Grid from '@mui/material/Grid2';
import ColorsButton from "@components/input/buttons/ColorsButton";

const colors = ["red","green","blue","yellow","orange","purple","black","gray","white"];

interface Props { 
  color: string;
  onChange: (changed: string) => void;
}

export default function ColorButtonBox({ 
  color,
  onChange
}: Props) {
  const [open, setOpen] = useState(false);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState<HTMLDivElement | null>(null);

  const renderExtras = () => {
    return [
      <Popover key="rolls"
        open={ popoverAnchorEl !== null && open }
        anchorEl={popoverAnchorEl}
        onClose={() => {
          setPopoverAnchorEl(null);
          setOpen(false);
        }}
        onBlur={() => {
          setPopoverAnchorEl(null);
          setOpen(false);
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        { open &&
          <div style={{ 
            width: "90px", 
            height: "90px", 
            cursor: "pointer" 
            }}>
            <Grid container spacing={0} direction="row" style={{ cursor: "pointer" }}>
              { renderColorRows() }
            </Grid>
          </div>
        }
      </Popover>
    ];
  }

  const renderColorRows = () => {
    return colors.map(c => {
      return (
        <Grid
          key={c}
          style={{ 
            backgroundColor: c, 
            height: "30px",
            border: (color === c ? "2px solid black" : "") 
          }}
          onClick={() => {
            onChange(c);
            setPopoverAnchorEl(null);
            setOpen(false);
          }}
          size={{
            xs: 4
          }}>
        </Grid>
      );
    });
  }

  return (
    <>
      <ColorsButton
        color={color}
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          setOpen(true);
          setPopoverAnchorEl(event.currentTarget);
        }}
      />
      { renderExtras() }
    </>
  );
}
